import httpUtils from "../../utils/HttpUtils";

class OnestopProjectSupervisorService {
  //获取整包项目案例
  async cases(supervisorId = "", status = "5", pageNo = 1, companyId = "") {
    let result = null;
    try {
      result = await httpUtils.post("/server/project/supervisor/list", { supervisorId, status, pageNo, companyId });
    } catch (e) {
      console.log("连接失败", e);
      result = { code: 1, msg: "连接失败" };
    }
    return result;
  }

  //获取整包项目列表
  async list(supervisorId = "", status = "", pageNo = 1, companyId = "") {
    let result = null;
    try {
      result = await httpUtils.post("/server/project/supervisor/list", { supervisorId, status, pageNo, companyId });
    } catch (e) {
      console.log("连接失败", e);
      result = { code: 1, msg: "连接失败" };
    }
    return result;
  }
}
export default new OnestopProjectSupervisorService();
